export enum PaymentMethodFields {
	ACCOUNT_NUMBER = "ACCOUNT_NUMBER",
	CARD_NUMBER = "CARD_NUMBER",
	IBAN = "IBAN",
	BENEFICIARY_COUNTRY = "BENEFICIARY_COUNTRY"
}
